import { applyTimezoneOffset } from '@/common/timezone/timezone.helper';
import { IDocument } from '@lib-shared/types/Document';
import { IUpdateDocument } from '@/document-edit/assembler/document/types/update-document';

export class DocumentHelper {
  static correctDates(document: IDocument): IDocument {
    if (!document) {
      return null;
    }
    return {
      ...document,
      expirationDate: applyTimezoneOffset(document.expirationDate, true),
      contractEndDate: applyTimezoneOffset(document.contractEndDate, true),
      contractStartDate: applyTimezoneOffset(document.contractStartDate, true),
    };
  }

  static correctDatesUpdate(payload: IUpdateDocument): IUpdateDocument {
    const res: IUpdateDocument = payload;
    if (res.contractStartDate) {
      res.contractStartDate = applyTimezoneOffset(payload.contractStartDate, false);
    }
    if (res.contractEndDate) {
      res.contractEndDate = applyTimezoneOffset(payload.contractEndDate, false);
    }
    if (res.expirationDate) {
      res.expirationDate = applyTimezoneOffset(payload.expirationDate, false);
    }
    return res;
  }
}
